Object.defineProperty(exports, '__esModule', { value: true });
exports.mediaQueries =
  exports.DeviceDimensions =
  exports.PLANET_STATE_SESSION_STORAGE_KEY =
  exports.infoPages =
  exports.lowercasePlanetNamesPartialRegex =
  exports.STARTING_PLANET =
  exports.PLANET_NAMES =
    void 0;
exports.PLANET_NAMES = [
  'Mercury',
  'Venus',
  'Earth',
  'Mars',
  'Jupiter',
  'Saturn',
  'Uranus',
  'Neptune',
];
exports.STARTING_PLANET = exports.PLANET_NAMES[0].toLocaleLowerCase();
exports.lowercasePlanetNamesPartialRegex = exports.PLANET_NAMES.map(planet =>
  planet.toLocaleLowerCase()
).join('|');
exports.infoPages = ['overview', 'structure', 'surface'];
exports.PLANET_STATE_SESSION_STORAGE_KEY = 'currentPlanetState';
var DeviceDimensions;
(function (DeviceDimensions) {
  DeviceDimensions['Mobile'] = '400px';
  DeviceDimensions['Tablet'] = '768px';
  DeviceDimensions['Desktop'] = '1440px';
})((DeviceDimensions = exports.DeviceDimensions || (exports.DeviceDimensions = {})));
exports.mediaQueries = {
  tablet: `@media only screen and (min-width: ${DeviceDimensions.Tablet}) `,
  desktop: `@media only screen and (min-width: ${DeviceDimensions.Desktop}) `,
};
